import { createAction, props } from '@ngrx/store';

import { Admin, ServiceProvider } from '@models';

// Fetch Service Providers:
export const fetchServiceProviders = createAction('[Service Provider] Fetch Initiated');
export const fetchServiceProvidersSuccess = createAction(
  '[Service Provider] Fetch Success',
  props<{ serviceProviders: ServiceProvider[] }>()
);
export const fetchServiceProvidersFailed = createAction(
  '[Service Provider] Fetch Failed',
  props<{ error: Error }>()
);

// Fetch Service Provider By Id:
export const fetchServiceProviderById = createAction(
  '[Service Provider] Fetch By Id Initiated',
  props<{ id: string }>()
);
export const fetchCurrentServiceProvider = createAction(
  '[Service Provider] Fetch Current By Id Initiated'
);
export const fetchServiceProviderByIdSuccess = createAction(
  '[Service Provider] Fetch By Id  Success',
  props<{ serviceProvider: ServiceProvider | null }>()
);
export const fetchServiceProviderByIdFailed = createAction(
  '[Service Provider] Fetch By Id  Failed',
  props<{ error: Error }>()
);

// Fetch service provider admins:
export const fetchCurrentServiceProviderAdmins = createAction(
  '[Service Provider] Fetch Current Admins Initiated'
);
export const fetchCurrentServiceProviderAdminsSuccess = createAction(
  '[Service Provider] Fetch Admins Success',
  props<{ serviceProviderId: string; admins: Admin[] }>()
);
export const fetchCurrentServiceProviderAdminsFailed = createAction(
  '[Service Provider] Fetch Admins Failed',
  props<{ error: Error }>()
);

// Update Service Provider:
export const updateServiceProvider = createAction(
  '[Service Provider] Update Initiated',
  props<{ serviceProvider: ServiceProvider }>()
);
export const updateServiceProviderSuccess = createAction(
  '[Service Provider] Update Success',
  props<{
    serviceProvider: ServiceProvider;
  }>()
);
export const updateServiceProviderFailed = createAction(
  '[Service Provider] Update Failed',
  props<{ error: Error }>()
);

// Update Service Provider Image:
export const updateServiceProviderImage = createAction(
  '[Service Provider] Update Image Initiated',
  props<{ file: File; serviceProvider: ServiceProvider }>()
);
export const updateServiceProviderImageSuccess = createAction(
  '[Service Provider] Update Image Success',
  props<{
    serviceProvider: ServiceProvider;
  }>()
);
export const updateServiceProviderImageFailed = createAction(
  '[Service Provider] Update Image Failed',
  props<{ error: Error }>()
);

// service provider admin actions
export const addServiceProviderAdmin = createAction(
  '[Service Provider] Add Admin Initiated',
  props<{ serviceProvider: ServiceProvider; admin: Admin }>()
);
export const addServiceProviderAdminSuccess = createAction(
  '[Service Provider] Add Admin Success',
  props<{
    serviceProvider: ServiceProvider;
    admin: Admin;
  }>()
);
export const addServiceProviderAdminFailed = createAction(
  '[Service Provider] Add Admin Failed',
  props<{ error: Error }>()
);


